@if (showSpinner) {
  <app-loader> </app-loader>
}
<div class="main-wrapper">
    <div class="outer-wrapper">
        <div class="add-payroll-manual-main" *ngIf="!isLoading">
            <div class="add-payroll-manual-head">

                <div class="common-head head-left">
                    <svg (click)="goBack()" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 7H1M1 7L7 13M1 7L7 1" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"  />
                    </svg>
                    <h1>Add Payroll <span>({{ monthChar }} {{ monthYear }})</span></h1>
                </div>
                <div class="common-head head-right">
                    <div class="action-button" (click)="paidLeavesnav()" *ngIf="counts?.pending_leave_count > 0">
                        <img src="../../../../assets/theme1/smal-icons/paid-leave.png" alt="Missing icon">
                        <div class="action-button-content">
                            <h2>Paid Leaves Request:<span>{{counts?.pending_leave_count || 0}}</span></h2>

                        </div>
                    </div>

                    <div class="action-button" (click)="attendanceReq()" *ngIf="counts?.pending_attendance_correction_count > 0">
                        <img src="../../../../assets/theme1/smal-icons/attendance-req.png" alt="Missing icon">
                        <div class="action-button-content">

                            <h2>Attendance Request:<span>{{counts?.pending_attendance_correction_count || 0}}</span></h2>
                        </div>
                    </div>
                    <div class="action-button" (click)="loanReq()" *ngIf="counts?.loan_other_count > 0">
                        <img src="../../../../assets/theme1/smal-icons/loan-req.png" alt="Missing icon">
                        <div class="action-button-content">
                            <h2>Loan Request:<span>{{counts?.loan_other_count || 0}}</span></h2>
                        </div>
                    </div>

                    <div class="action-button" (click)="absentReq()" *ngIf="counts?.absent_count > 0">
                        <img src="../../../../assets/theme1/smal-icons/attendance-req.png" alt="Missing icon">
                        <div class="action-button-content">
                            <h2>Absents:<span>{{counts?.absent_count || 0}}</span></h2>
                        </div>
                    </div>

                    <div class="action-button" *ngIf="counts?.paid_leave_count > 0">
                        <img src="../../../../assets/theme1/smal-icons/paid-leave.png" alt="Missing icon">
                        <div class="action-button-content">
                            <h2>Paid Leave Days:<span>{{counts?.paid_leave_count || 0}}</span></h2>
                        </div>
                    </div>

                    <div class="action-button" *ngIf="counts?.unpaid_leave_count > 0">
                        <img src="../../../../assets/theme1/smal-icons/unpaid-leave.png" alt="Missing icon">
                        <div class="action-button-content">
                            <h2>Unpaid Leave Days:<span>{{counts?.unpaid_leave_count || 0}}</span></h2>
                        </div>
                    </div>

                </div>

            </div>
            <div class="add-payroll-manual-body">
                <div class="input-fields-main">
                    <div class="input-group">
                        <label>Tax On Salary</label>
                        <div class="input-wrapper">
                            <input
                                type="number"
                                placeholder="Tax On Salary..."
                                [(ngModel)]="taxAmount"
                                (input)="calculateSalary()"
                            />
                        </div>
                    </div>

                    <div class="input-group">
                        <label>Advance Amount</label>
                        <div class="input-wrapper">
                            <input
                                type="number"
                                placeholder="Advance Amount..."
                                [(ngModel)]="advanceAmount"
                                (input)="calculateSalary()"
                            />
                        </div>
                    </div>

                    <div class="input-group">
                        <label>Other Deduction</label>
                        <div class="input-wrapper">
                            <input
                                type="number"
                                placeholder="Other Deduction..."
                                [(ngModel)]="otherDeduction"
                                (input)="calculateSalary()"
                            />
                        </div>
                    </div>


                    <div class="input-group">
                        <label>Compensation Amount</label>
                        <div class="input-wrapper">
                            <input
                                type="number"
                                placeholder="Compensation Amount..."
                                [(ngModel)]="compensationAmount"
                                (input)="calculateSalary()"
                                />
                        </div>
                    </div>


                    <div class="input-group">
                        <label>Extra Overtime (Hours)</label>
                        <div class="input-wrapper">
                            <input
                                type="number"
                                placeholder="Extra Overtime Hours..."
                                [(ngModel)]="extraOvertimeHours"
                                (input)="calculateSalary()"
                                />
                        </div>
                    </div>


                    <div class="input-group">
                        <label>Payroll Type</label>
                    </div>
                    <div class="payment-methord-sec">

                        <!-- Bank Transfer -->
                        <div class="payroll-card" [class.active]="payrollType === 'bank_transfer'">
                            <label class="card-header">
                                <div class="left">
                                    <div class="icon bank">
                                        <img src="../../../../assets/theme1/smal-icons/bank-ico.svg" alt="Missing icon">
                                    </div>
                                    <div>
                                        <h4>Bank Transfer</h4>
                                        <p>Salary credited to employee’s bank account</p>
                                    </div>
                                </div>

                                <input type="radio" name="payrollType" value="bank_transfer" [(ngModel)]="payrollType" />
                                <span class="radio-ui"></span>
                            </label>

                            <!-- Bank Details -->
                            <div class="bank-details" *ngIf="payrollType === 'bank_transfer'">
                                <div class="transfer-options">
                                   <label [class.active]="bankTransferType === 'full'">
                                    <input
                                        type="radio"
                                        name="bankType"
                                        value="full"
                                        [(ngModel)]="bankTransferType"
                                        (change)="onTransferTypeChange()" />
                                    <span class="radio-ui"></span>
                                    Fully transfer
                                    </label>

                                    <label [class.active]="bankTransferType === 'partial'">
                                        <input type="radio" name="bankType" value="partial"
                                            [(ngModel)]="bankTransferType" />
                                        <span class="radio-ui"></span>
                                        Partial transfer
                                    </label>
                                </div>

                              <div class="amount-box" *ngIf="bankTransferType === 'partial'">
                                <p>How much amount you want to transfer through bank?</p>
                                    <div class="amount-input">
                                        <input
                                        type="number"
                                        placeholder="Rs. Enter amount"
                                        [(ngModel)]="partialAmount"
                                        (input)="updateRemaining()"
                                        />
                                        <div class="remaining">
                                        Remaining: <b>{{ remainingAmount | number }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Cash -->
                        <div class="payroll-card" [class.active]="payrollType === 'cash'">
                            <label class="card-header">
                                <div class="left">
                                    <div class="icon cash">
                                        <img src="../../../../assets/theme1/smal-icons/cash.svg" alt="Missing icon">
                                    </div>
                                    <div>
                                        <h4>Cash Payment</h4>
                                        <p>Salary paid in cash by the company.</p>
                                    </div>
                                </div>

                                <input type="radio" name="payrollType" value="cash" [(ngModel)]="payrollType" />
                                <span class="radio-ui"></span>
                            </label>
                        </div>

                        <!-- Final Settlement -->
                        <div class="payroll-card" [class.active]="payrollType === 'final'">
                            <label class="card-header">
                                <div class="left">
                                    <div class="icon final">
                                        <img src="../../../../assets/theme1/smal-icons/final-settlement.svg"
                                            alt="Missing icon">
                                    </div>
                                    <div>
                                        <h4>Final Settlement</h4>
                                        <p>Final payment for an employee’s service period.</p>
                                    </div>
                                </div>

                                <input type="radio" name="payrollType" value="final" [(ngModel)]="payrollType" />
                                <span class="radio-ui"></span>
                            </label>
                        </div>


                    </div>

                </div>
                <div class="user-payrol-detail">
                    <div class="user-detail-main-head">
                        <div class="user-payrol-head">
                            <h1>  
                              {{ (user?.first_name || '') + ' ' + (user?.last_name || '') || 'N/A' }}
                                <span>({{ user?.attendance_user_id || '-' }})</span>
                            </h1>
                            <div class="generate-payroll-btn" (click)="generateSalary()">
                                Generate Payroll
                            </div>

                        </div>
                        <div class="user-detail-content">
                            <div class="user-contet-left-side">
                                <div class="user-detail-row">
                                    <svg width="13" height="15" viewBox="0 0 13 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.5 5.83333H0.5M9.16667 0.5V3.16667M3.83333 0.5V3.16667M3.7 13.8333H9.3C10.4201 13.8333 10.9802 13.8333 11.408 13.6153C11.7843 13.4236 12.0903 13.1176 12.282 12.7413C12.5 12.3135 12.5 11.7534 12.5 10.6333V5.03333C12.5 3.91323 12.5 3.35318 12.282 2.92535C12.0903 2.54903 11.7843 2.24307 11.408 2.05132C10.9802 1.83333 10.4201 1.83333 9.3 1.83333H3.7C2.5799 1.83333 2.01984 1.83333 1.59202 2.05132C1.21569 2.24307 0.909734 2.54903 0.717987 2.92535C0.5 3.35318 0.5 3.91323 0.5 5.03333V10.6333C0.5 11.7534 0.5 12.3135 0.717987 12.7413C0.909734 13.1176 1.21569 13.4236 1.59202 13.6153C2.01984 13.8333 2.5799 13.8333 3.7 13.8333Z"
                                            stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <p>Joining Date</p>
                                    <h1>: {{ user?.joining_date || '-' }}</h1>
                                </div>

                                <div class="user-detail-row">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.5 11.8333C2.05719 10.1817 4.17134 9.16667 6.5 9.16667C8.82866 9.16667 10.9428 10.1817 12.5 11.8333M9.5 3.5C9.5 5.15685 8.15685 6.5 6.5 6.5C4.84315 6.5 3.5 5.15685 3.5 3.5C3.5 1.84315 4.84315 0.5 6.5 0.5C8.15685 0.5 9.5 1.84315 9.5 3.5Z"
                                            stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <p>Employment Status</p>
                                    <h1>: {{ user?.employee_type || '-' }}</h1>
                                </div>

                                <div class="user-detail-row">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.16667 0.833333V2.63333C7.16667 3.75344 7.16667 4.31349 7.38465 4.74131C7.5764 5.11764 7.88236 5.4236 8.25869 5.61535C8.68651 5.83333 9.24656 5.83333 10.3667 5.83333H12.1667M12.5 7.15882V9.3C12.5 10.4201 12.5 10.9802 12.282 11.408C12.0903 11.7843 11.7843 12.0903 11.408 12.282C10.9802 12.5 10.4201 12.5 9.3 12.5H3.7C2.5799 12.5 2.01984 12.5 1.59202 12.282C1.21569 12.0903 0.909734 11.7843 0.717987 11.408C0.5 10.9802 0.5 10.4201 0.5 9.3V3.7C0.5 2.5799 0.5 2.01984 0.717987 1.59202C0.909734 1.21569 1.21569 0.909734 1.59202 0.717987C2.01984 0.5 2.5799 0.5 3.7 0.5H5.84118C6.33036 0.5 6.57496 0.5 6.80513 0.55526C7.0092 0.604254 7.20429 0.685062 7.38324 0.79472C7.58507 0.918403 7.75802 1.09135 8.10393 1.43726L11.5627 4.89608C11.9086 5.24198 12.0816 5.41493 12.2053 5.61676C12.3149 5.79571 12.3957 5.9908 12.4447 6.19487C12.5 6.42505 12.5 6.66964 12.5 7.15882Z"
                                            stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <p>Department</p>
                                    <h1>: {{ user?.department || '-' }}</h1>
                                </div>

                                <div class="user-detail-row">
                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.7634 7.24476C13.7634 3.51973 10.7437 0.5 7.01868 0.5C3.99533 0.5 1.43659 2.48923 0.579896 5.23027C0.525018 5.40585 0.497579 5.49365 0.500168 5.60343C0.502273 5.69269 0.529406 5.80297 0.56896 5.88303C0.617604 5.98148 0.692713 6.05658 0.842924 6.20679L8.05693 13.4205C8.20713 13.5707 8.28225 13.6458 8.3807 13.6944C8.46075 13.734 8.57104 13.7611 8.6603 13.7632C8.77008 13.7658 8.85788 13.7383 9.03346 13.6834C11.7743 12.8267 13.7634 10.268 13.7634 7.24476Z"
                                            stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M1.39422 5.65606C1.55456 5.64466 1.71644 5.63886 1.87968 5.63886C5.6047 5.63886 8.62444 8.65859 8.62444 12.3836C8.62444 12.5469 8.61864 12.7087 8.60723 12.8691C8.58731 13.1492 8.57735 13.2893 8.49569 13.3758C8.42937 13.446 8.3162 13.4883 8.22007 13.4786C8.10171 13.4668 7.99406 13.3591 7.77877 13.1439L1.11945 6.48452C0.904159 6.26924 0.796515 6.16159 0.784658 6.04323C0.775028 5.94709 0.817263 5.83392 0.887523 5.7676C0.974028 5.68595 1.11409 5.67599 1.39422 5.65606Z"
                                            stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <p>Designation</p>
                                    <h1>: {{ user?.designation?.designation_name || '-' }}</h1>
                                </div>


                            </div>
                            <div class="user-contet-right-side">
                                <p>Payroll Type</p>
                               <h1>
                                      {{ payrollType ? payrollTypeLabelMap[payrollType] : '-' }}
                                </h1>

                            </div>
                        </div>
                    </div>
                    <div class="user-payroll-table">
                        <table class="responsive-table">
                            <thead>
                                <tr>
                                    <th>Category</th>
                                    <th>Duration</th>
                                    <th>Amount (PKR)</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td>Overtime</td>
                                    <td>{{ getTotalOvertimeHours() | number:'1.1-2' }} Hours</td>
                                    <td>+ {{ (overtimeAmount | number:'1.1-2') || '0' }}</td>
                                </tr>
                                <tr>
                                    <td>Late Check-In</td>
                                    <td>{{ user?.user_salary[0]?.late_check_in || '0' }} Hours</td>
                                    <td>- {{ (user?.user_salary[0]?.late_check_in_amount | number:'1.1-2') || '0' }}</td>
                                </tr>
                                <tr>
                                    <td>Short Hours</td>
                                    <td>{{ (user?.user_salary[0]?.short_hours ?? 0) | number:'1.1-2' }} Hours</td>
                                    <td>- {{ (user?.user_salary[0]?.short_hours_amount | number:'1.1-2' ) || '0' }}</td>
                                </tr>
                                <tr>
                                    <td>Absents</td>
                                    <td>{{ (user?.user_salary[0]?.absents ?? 0) | number:'1.1-2' }} Days</td>
                                    <td>- {{( user?.user_salary[0]?.absents_amount | number:'1.1-2') || '0' }}</td>
                                </tr>
                                <tr>
                                     <td>Unpaid Leaves</td>
                                   <td>{{ (user?.user_salary[0]?.unpaid_leaves ?? 0) | number:'1.1-2' }} Days</td>
                                   <td>- {{ (user?.user_salary[0]?.unpaid_leaves_amount | number:'1.1-2') || '0' }}</td>
                                </tr>
                                <tr>
                                    <td>Advance Amount</td>
                                    <td>-</td>
                                     <td>{{ (advanceAmount | number:'1.1-2') || 0 }}</td>
                                </tr>
                                <tr>
                                    <td>Loan Amount</td>
                                    <td>-</td>
                                    <td>{{ (user?.user_salary[0]?.loan_deduction_amount | number:'1.1-2') || '0' }}</td>
                                </tr>
                                <tr>
                                    <td>Other Deduction</td>
                                    <td>-</td>
                                    <td>{{ (user?.user_salary[0]?.other_deduction | number:'1.1-2') || '0' }}</td>
                                </tr>

                            </tbody>
                        </table>
                        <div class="total-calculations">
                            <div class="inner-calculations">
                                <p>Gross Salary  <span>{{ user?.user_salary[0]?.basic_salary || '0' }}/-</span></p>
                                 <p>Total Deduction  <span class="deduction">− {{ totalDeduction  | number:'1.1-2' }}/-</span></p>
                                 <p>Compensations  <span class="compensation">+ {{ compensationAmount  | number:'1.1-2' }}/-</span></p>
                                 <p>Tax  <span class="deduction">−{{ taxAmount | number:'1.1-2' }} /-</span></p>
                                 <div class="net-salary">
                                   <p>Net Salary</p> 
                                   <p>{{ (current_released_salary ?? 0) | number:'1.0-0' }}/-</p>
                                 </div>
                            </div>
                            
                        </div>

                    </div>
                    <div class="user-payroll-footer">


                    </div>
                </div>
            </div>
            <div class="add-payroll-manual-foot">
                        <div class="action-buttons">
                            <div class="save-btn" (click)="saveSalary('draft')">
                                Save to Draft
                            </div>
                             <div class="appove-btn" (click)="saveSalary('approved')">
                                Approve
                            </div>
                     
                        </div>
            </div>
        </div>

        <!-- Skeleton Loader -->
        <div class="skeleton-wrapper" *ngIf="isLoading">
            <div class="skeliton-header">
                 <div class="payroll-summary-header-body-item release-amount skeleton-small-div" *ngIf="isLoading"></div>
                  <div class="payroll-summary-header-body-item release-amount skeleton-small-div" *ngIf="isLoading"></div>
            </div>
            <div class="skeliton-body">
                <div class="skeliton-left">
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div " *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div> 
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                     <div class="payroll-summary-header-body-item release-amount skeleton-big-div " *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div> 
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                     <div class="payroll-summary-header-body-item release-amount skeleton-big-div " *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div> 
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                </div>
                <div class="skeliton-right">
                  <div class="payroll-summary-header-body-item release-amount skeleton-big-div " *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div> 
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                     <div class="payroll-summary-header-body-item release-amount skeleton-big-div " *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div> 
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                     <div class="payroll-summary-header-body-item release-amount skeleton-big-div " *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div> 
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                    <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="isLoading"></div>
                  
                </div>
            </div>
           
        </div>
    </div>
</div>